module.exports = require('./Multiselect.vue')



// WEBPACK FOOTER //
// ./src/index.js